import { makeEntityScaffold } from '@classpass/saga-tools';

export const getCountries = makeEntityScaffold('SAGA.API.GET_COUNTRIES', client =>
  client.countries.get().then(data => data.countries)
);

export const classFeesByCountry = makeEntityScaffold(
  'SAGA.API.CLASS_FEES_BY_COUNTRY',
  (client, countryCode) => {
    return client.countries.getClassFees(countryCode).then(data => data.class_fees);
  },
  {
    defaultKey: (client, countryCode) => countryCode,
  }
);
